import type { App } from 'vue'
// @ts-ignore
import print from 'vue3-print-nb'

export default function (app: App) {
    app.use(print)
}
